import L from 'leaflet';

export const MarkerClusterIcon = (icon: L.Icon) =>
  new L.Icon({
    iconAnchor: [30, 55],
    iconSize: new L.Point(60, 75),
    ...icon.options,
  });
